/* Pure Desi — Corporate Diwali gifting page (2026-09-12): bulk order form.
   Steppers, line totals, the box count and subtotal, the over-threshold switch,
   one ajax add of every line to /cart/add.js stamped _order_type=diwali-preorder,
   then on to /cart. Over the threshold the bar offers "Send us your list", which
   copies the list into the enquiry form's message and scrolls there.
   The form carries data-pd-type="diwali": pd-diwali-mode.js intercepts a
   conflicting everyday bag in the capture phase and, after clearing, calls
   form.requestSubmit(), which lands back here. ES5 on purpose, like pd-diwali-mode.js. */
(function () {
  'use strict';
  if (window.__pdCorporate) return;
  window.__pdCorporate = true;

  function money(cents) {
    var n = cents % 100 ? (cents / 100).toFixed(2) : String(Math.round(cents / 100));   /* [LP-1] 29 Sep 2026: no ".00" on whole dollars */
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function init(form) {
    var threshold = parseInt(form.getAttribute('data-pd-threshold'), 10) || 100;
    var inputs = Array.prototype.slice.call(form.querySelectorAll('[data-pd-qty]'));
    var countEl = form.querySelector('[data-pd-count]');
    var totalEl = form.querySelector('[data-pd-total]');
    var addBtn = form.querySelector('[data-pd-add]');
    var listBtn = form.querySelector('[data-pd-tolist]');
    var overEl = form.querySelector('[data-pd-over]');
    var errEl = form.querySelector('[data-pd-err]');

    function qtyOf(input) {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 0) n = 0;
      if (n > 999) n = 999;
      return n;
    }
    function priceOf(input) {
      var row = input.closest('[data-pd-row]');
      var p = row && row.querySelector('[data-pd-price]');
      return p ? parseInt(p.getAttribute('data-pd-price'), 10) || 0 : 0;
    }
    function lines() {
      var out = [];
      inputs.forEach(function (input) {
        var q = qtyOf(input);
        if (q > 0) out.push({ id: parseInt(input.getAttribute('data-pd-variant'), 10), quantity: q, title: input.getAttribute('data-pd-title'), price: priceOf(input) });
      });
      return out;
    }
    function render() {
      var count = 0, total = 0;
      inputs.forEach(function (input) {
        var q = qtyOf(input), p = priceOf(input);
        var row = input.closest('[data-pd-row]');
        var line = row && row.querySelector('[data-pd-line]');
        if (line) line.innerHTML = q > 0 ? money(q * p) : '&nbsp;';
        if (row) row.classList.toggle('has-qty', q > 0);
        count += q; total += q * p;
      });
      if (countEl) countEl.textContent = String(count);
      if (totalEl) totalEl.textContent = money(total);
      var over = count > threshold;
      if (addBtn) { addBtn.hidden = over; addBtn.disabled = count === 0; }
      if (listBtn) listBtn.hidden = !over;
      if (overEl) overEl.hidden = !over;
      if (errEl) errEl.hidden = true;
    }
    function setQty(input, n) {
      if (input.disabled) return;
      input.value = String(Math.max(0, Math.min(999, n)));
      render();
    }

    form.addEventListener('click', function (e) {
      var dec = e.target.closest('[data-pd-dec]'), inc = e.target.closest('[data-pd-inc]');
      if (!dec && !inc) return;
      e.preventDefault();
      var input = (dec || inc).parentNode.querySelector('[data-pd-qty]');
      if (!input) return;
      setQty(input, qtyOf(input) + (inc ? 1 : -1));
    });
    form.addEventListener('input', function (e) { if (e.target.hasAttribute('data-pd-qty')) render(); });
    form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-pd-qty')) setQty(e.target, qtyOf(e.target)); });
    form.addEventListener('keydown', function (e) {
      /* Enter in a quantity field must not submit a half-built order */
      if (e.key === 'Enter' && e.target.hasAttribute('data-pd-qty')) { e.preventDefault(); e.target.blur(); }
    });

    /* Over the threshold: carry the list into the enquiry form */
    if (listBtn) listBtn.addEventListener('click', function () {
      var ta = document.querySelector('[data-pd-enquiry-message]');
      var ls = lines();
      if (!ta || !ls.length) return;
      var text = ls.map(function (l) { return l.quantity + ' × ' + l.title; }).join('\n');
      var count = ls.reduce(function (a, l) { return a + l.quantity; }, 0);
      var total = ls.reduce(function (a, l) { return a + l.quantity * l.price; }, 0);
      ta.value = text + '\n\n' + count + ' boxes, ' + money(total) + ' at retail before delivery. Please quote.';
      var hc = document.querySelector('[name="contact[Boxes or headcount]"]');
      if (hc && !hc.value) hc.value = count + ' boxes';
      setTimeout(function () { try { ta.focus({ preventScroll: true }); } catch (err) { /* older browsers */ } }, 400);
    });

    /* Bubble-phase submit: pd-diwali-mode.js runs first (capture) and either
       lets this through or opens its dialog and resubmits after clearing. */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ls = lines();
      if (!ls.length || !addBtn || addBtn.hidden) return;
      if (typeof fetch !== 'function') { location.href = '/collections/diwali'; return; }
      addBtn.classList.add('working');
      if (errEl) errEl.hidden = true;
      var items = ls.map(function (l) { return { id: l.id, quantity: l.quantity, properties: { _order_type: 'diwali-preorder' } }; });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (r.ok) { location.href = '/cart'; return null; }
        return r.json().catch(function () { return {}; }).then(function (d) {
          throw new Error((d && (d.description || d.message)) || 'That did not go through. Please try again.');
        });
      }).catch(function (err) {
        addBtn.classList.remove('working');
        if (errEl) { errEl.textContent = err && err.message ? err.message : 'That did not go through. Please try again.'; errEl.hidden = false; }
      });
    });

    /* The bar is sticky only while the form is on screen. A sticky-bottom
       element whose container is still below the viewport parks at the
       container's top edge, which would put the bar above the first row. */
    var bar = form.querySelector('[data-pd-bar]');
    if (bar) {
      var live = function () { bar.classList.toggle('is-live', form.getBoundingClientRect().top < window.innerHeight); };
      if (typeof IntersectionObserver === 'function') {
        new IntersectionObserver(live, { threshold: 0 }).observe(form);
      } else {
        window.addEventListener('scroll', live, { passive: true });
      }
      live();
    }

    render();
  }

  function boot() {
    var forms = document.querySelectorAll('form[data-pd-corporate]');
    for (var i = 0; i < forms.length; i++) init(forms[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
